import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import parseISO from 'date-fns/parseISO';
import { addMinutes } from 'date-fns';

export const formatUnixDate = (date, dateFormat = 'MMM dd, yyyy') => {
  const unixDate = fromUnixTime(date);
  return format(unixDate, dateFormat);
};

export const formatDate = ({ date, todayText, yesterdayText }) => {
  const dateValue = new Date(date);
  if (isToday(dateValue)) return todayText;
  if (isYesterday(dateValue)) return yesterdayText;
  return date;
};

export const formatDigitToString = val => {
  return val > 9 ? `${val}` : `0${val}`;
};

export const getTimezoneDate = (utcOffset, date = new Date()) => {
  const timeArr = utcOffset.slice(1, -1).split(':');
  const userTimezone = date.getTimezoneOffset();

  let minutesOffset = parseInt(timeArr[0]) * 60 + parseInt(timeArr[1]);
  if (utcOffset[0] === '-') {
    minutesOffset *= -1;
  }
  minutesOffset += userTimezone;

  const formattedDate = addMinutes(new Date(), minutesOffset);

  return formattedDate;
};

export const buildDateFromTime = (hr, min, utcOffset, date = new Date()) => {
  const today = format(getTimezoneDate(utcOffset, date), 'yyyy-MM-dd');
  const hour = formatDigitToString(hr);
  const minute = formatDigitToString(min);
  const timeString = `${today}T${hour}:${minute}:00${utcOffset}`;
  return parseISO(timeString);
};
